import styled from 'styled-components';
export const TableCellGroupHeader = styled.div `
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 4px ${({ $complexTitle }) => ($complexTitle ? '12px' : '24px')} 4px 24px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_1};
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey100_1};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 8px;
    bottom: 0;
    // TODO: replace with right color after color refactoring
    background: ${({ theme }) => theme.colors.link30_1};
  }
`;
